module.exports = __webpack_public_path__ + "static/media/samochody.c97e46b2.svg";